<template>
  <div class="payment-thank-you">
    <section class="payment-thank-you__panel">
      <div class="payment-thank-you__status" :class="{ 'payment-thank-you__status--cancelled': isCancelled }">
        {{ statusLabel }}
      </div>

      <h1>{{ title }}</h1>
      <p>{{ message }}</p>

      <div v-if="paymentReference" class="payment-thank-you__reference">
        <span>Betalingsreference</span>
        <strong>{{ paymentReference }}</strong>
      </div>

      <router-link to="/" class="payment-thank-you__button">
        Til forsiden
      </router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PaymentThankYou',
  computed: {
    queryParams() {
      const params = new URLSearchParams(window.location.search || '');
      Object.keys(this.$route.query || {}).forEach((key) => {
        if (!params.has(key)) {
          params.set(key, this.$route.query[key]);
        }
      });
      return params;
    },
    paymentStatus() {
      return this.queryParams.get('quickpay') || this.$route.query.quickpay || 'paid';
    },
    paymentReference() {
      return this.queryParams.get('payment') || this.$route.query.payment || '';
    },
    isCancelled() {
      return this.paymentStatus === 'cancelled';
    },
    statusLabel() {
      return this.isCancelled ? 'Betaling annulleret' : 'Betaling modtaget';
    },
    title() {
      return this.isCancelled ? 'Betalingen blev annulleret' : 'Tak for din betaling';
    },
    message() {
      if (this.isCancelled) {
        return 'Betalingen blev ikke gennemført. Kontakt VALiZO, hvis du har brug for hjælp.';
      }
      return 'Vi har modtaget betalingen. En kvittering bliver sendt til den emailadresse, der er angivet for betalingen.';
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-thank-you {
  min-height: calc(100vh - 105px);
  background: #f6f9fc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;
}

.payment-thank-you__panel {
  width: 100%;
  max-width: 620px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 12px 32px rgba(31, 50, 75, 0.08);
}

.payment-thank-you__status {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 12px;
  border-radius: 4px;
  background: #e8f6ef;
  color: #1d7a47;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 18px;
}

.payment-thank-you__status--cancelled {
  background: #fff1f1;
  color: #b42318;
}

h1 {
  color: #1d3557;
  font-size: 32px;
  line-height: 1.2;
  margin: 0 0 14px;
}

p {
  color: #4a5568;
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
}

.payment-thank-you__reference {
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  padding: 18px 0;
  margin: 28px 0;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  color: #4a5568;
}

.payment-thank-you__reference strong {
  color: #1d3557;
  text-align: right;
}

.payment-thank-you__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  padding: 0 22px;
  background: #2ea3f2;
  color: #fff;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 600;
}

@media (max-width: 600px) {
  .payment-thank-you {
    align-items: flex-start;
    padding-top: 32px;
  }

  .payment-thank-you__panel {
    padding: 28px 22px;
  }

  h1 {
    font-size: 26px;
  }

  .payment-thank-you__reference {
    flex-direction: column;
    gap: 6px;
  }

  .payment-thank-you__reference strong {
    text-align: left;
    overflow-wrap: anywhere;
  }
}
</style>
